<template>
  <div class="d-flex flex-row">
    <div v-for="(action, index) in actions" :key="index">
      <div v-if="!action.show || action.show(itemRecord)">
        <div v-if="action.type == 'divider'" />
        <div
          style="padding-left: 2px; padding-right: 2px; color: #063662; cursor: pointer;"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          :title="action.label"
          v-if="action.type == 'function'"
          @click="action.acao(itemRecord)"
        >
          <b-icon v-if="action.icon" :icon="action.icon" aria-hidden="true" />
        </div>
        <div
          v-if="action.type == 'gerarPdf'"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          :title="action.label"
          style="padding-left: 2px; padding-right: 2px; color: #063662; cursor: pointer;"
          @click="pegaItemPdf(action.acao(itemRecord))"
        >
          <b-icon v-if="action.icon" :icon="action.icon" aria-hidden="true" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { geradorDePdf } from "./utils/geradorDePdf";

export default {
  inheritAttrs: false,
  props: {
    actions: [String, Number, Boolean, Function, Array],
    itemRecord: Object,
    cols: String,
    sm: String,
    md: String,
    classFormGroup: {
      type: String,
      default: "",
    },
    label: String,
    isPdf: Boolean,
    casePdf: String,
    isXls: Boolean,
    caseXls: String,
  },
  data() {
    return {
      responsiveCols: String,
    };
  },
  mounted() {
    this.responsiveCols =
      (this.cols !== undefined ? `col-${this.cols} ` : "") +
        (this.sm !== undefined ? `col-sm-${this.sm} ` : "") +
        (this.md !== undefined ? `col-md-${this.md} ` : "") || "col-12 ";
  },
  methods: {
    async pegaItemPdf(item) {
      const dadosParaOPdf = await item;
      geradorDePdf(dadosParaOPdf, this.casePdf);
    },
  },
};
</script>
<style>
.lb-button-acao {
  background-color: transparent !important;
  color: #66615b !important;
  border-color: transparent !important;
}
.lb-button-acao::after {
  display: none !important;
}
</style>
